import React from 'react';
import { Box, Button, Text } from 'grommet';
import PropTypes from 'prop-types';
import { API, ContactService } from '@enrich/shared-lib';

export const ProgramActions = ({ contact, revalidate }) => {
    const displayProfileActions =
        !contact.attributes.isApproved &&
        ['applied', 'waitlisted'].includes(
            contact.attributes.enrichProgramStatus,
        );

    if (!displayProfileActions) return null;

    const borderColor =
        contact.attributes.enrichProgramStatus == 'waitlisted'
            ? 'enrich-accent'
            : 'enrich-green-light';

    const handleStatusUpdate = async (status) => {
        await updateProgramStatus(contact.id, status);
        revalidate();
    };

    const hasSubmittedDetailedSurvey = Boolean(
        contact.attributes.detailedSurveySubmittedAt,
    );

    return (
        <Box
            align="center"
            background="white"
            border={{
                color: borderColor,
                size: '3px',
            }}
            gap="small"
            justify="center"
            pad="medium"
            round="6px">
            <Box direction="row" gap="small">
                <Button
                    primary
                    size="large"
                    label="Approve application"
                    disabled={!hasSubmittedDetailedSurvey}
                    onClick={() => handleStatusUpdate('accepted')}
                    tip={
                        hasSubmittedDetailedSurvey
                            ? 'The applicant will receive a message welcoming them to the program.'
                            : 'Waiting on the detailed application survey.'
                    }
                />
                {contact.attributes.enrichProgramStatus != 'waitlisted' && (
                    <Button
                        secondary
                        size="large"
                        label="Waitlist"
                        onClick={() => handleStatusUpdate('waitlisted')}
                    />
                )}
                <Button
                    secondary
                    size="large"
                    label="Reject application"
                    onClick={() => handleStatusUpdate('denied')}
                />
            </Box>
            {contact.attributes.enrichProgramStatus == 'waitlisted' && (
                <Text>{contact.attributes.firstName} is waitlisted.</Text>
            )}
        </Box>
    );
};

const updateProgramStatus = async (contactId, status) => {
    if (status == 'accepted') {
        try {
            return await new ContactService().approveContact(contactId);
        } catch (error) {
            console.log(error);
        }
    }

    const contactData = {
        enrichProgramStatus: status,
    };

    try {
        const response = await API.put(
            `/api/contacts/${contactId}/update-program-status`,
            {
                data: contactData,
            },
        );
        return response.data.data;
    } catch (error) {
        console.log(error);
    }
};

ProgramActions.propTypes = {
    contact: PropTypes.shape({
        id: PropTypes.string,
        attributes: PropTypes.shape({
            enrichProgramStatus: PropTypes.string,
            firstName: PropTypes.string,
            isApproved: PropTypes.bool,
            detailedSurveySubmittedAt: PropTypes.string,
        }),
    }),
    revalidate: PropTypes.func,
};
